import React from "react";
import { Button, Paper, Typography } from "@mui/material";

// Barra flotante fija al pie de la pantalla, para asignar o descartar una
// selección múltiple de pedidos hecha desde las tarjetas.
const BarraSeleccionMultiple = ({ cantidad, onAsignar, onLimpiar }) => {
  if (cantidad === 0) return null;

  return (
    <Paper
      elevation={6}
      sx={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1200,
        p: 1.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1.5,
        flexWrap: "wrap",
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {cantidad} seleccionado{cantidad === 1 ? "" : "s"}
      </Typography>
      <Button color="success" variant="contained" onClick={onAsignar}>
        Asignar Pedidos
      </Button>
      <Button color="error" variant="outlined" onClick={onLimpiar}>
        Borrar Selección
      </Button>
    </Paper>
  );
};

export default BarraSeleccionMultiple;
